
import { Vue, Component, Watch, Model, Prop } from "vue-property-decorator";
import { AmTextField } from "@afe/amui/src/components/TextField";
import { errorText } from "./errorText";

@Component({
  components: {
    AmTextField
  }
})
export default class extends Vue {
  errorText = "";
  passwordType = true;
  @Model("model") readonly value?: string;
  @Prop(Object) readonly messages!: Record<string, string>;
  @Prop(Object) readonly validator?: object;

  get type() {
    return this.passwordType ? "password" : "text";
  }

  get icon() {
    return this.passwordType ? "visibility_off" : "visibility";
  }

  toggleType() {
    this.passwordType = !this.passwordType;
  }

  @Watch("validator", { deep: true })
  onError(validator: any) {
    this.errorText = errorText(validator, this.messages);
  }
}
